import axios from 'axios';
import toastr from 'toastr';
import config from '../../config/index';
import routes from '../../constants/routes';
import {
  ADD_BANK_ACCOUNT,
  ADD_BANK_ACCOUNT_ERROR,
  DELETE_ADD_BANK_ACCOUNT_ERROR,
  ADD_BANK_ACCOUNT_LOADING
} from '../types';
import logoutAction from '../auth.actions/logout.action';

export const addBankDetails = addBank => ({
  type: ADD_BANK_ACCOUNT,
  addBank
});

const addBankDetailsLoading = () => ({
  type: ADD_BANK_ACCOUNT_LOADING
});

const addBankDetailsError = error => ({
  type: ADD_BANK_ACCOUNT_ERROR,
  error,
});

export const deleteAddBankDetailsError = () => ({
  type: DELETE_ADD_BANK_ACCOUNT_ERROR
});

const addBankDetailsRequest = bankDetails => (dispatch) => {
  dispatch(addBankDetailsLoading());
  return axios.post(`${config.apiUrl}${routes.ADDBANKACCOUNT}`, bankDetails).then((response) => {
    const { responseMessage } = response.data;
    dispatch(addBankDetails(response.data));
    toastr.success(responseMessage);
  }).catch((error) => {
    dispatch(addBankDetailsLoading());
    const { data } = error.response;
    if (error.response === undefined) {
      window.location.href = '/error';
    }
    if (error.response.status === 401) {
      const { status } = error.response;
      dispatch(logoutAction(status));
    }
    dispatch(addBankDetailsError(data.responseMessage));
    throw error;
  });
};


export default addBankDetailsRequest;
